import React, { useState } from 'react'
import { Icon } from '@manychat/manyui'

import { NODE_CLEAR_BUTTON_ID } from 'common/builder/components/chart/FlowChart/constants/index'
import { useFlowChartState } from 'common/builder/components/chart/FlowChart/contexts/FlowChartStateContext'
import { convertToIconString } from 'common/builder/components/chart/FlowChart/lib/utils/convertToIconString'
import { IconSizes, Colors } from 'common/builder/components/chart/FlowChart/nodes/shared/styles'

import { FlowCaption, CloseIcon } from './GotoContent.styles'
import { OpenFlowButton } from './OpenFlowButton'

interface GotoContentProp {
  flowName: string
  readonly: boolean
  onClose: () => void
  onFlowOpen: () => void
}

const RedIconString = convertToIconString(Icon.Close, {
  size: IconSizes.LARGE,
  color: Colors.DANGER,
})

const GrayIconString = convertToIconString(Icon.Close, {
  size: IconSizes.LARGE,
  color: Colors.Tints.NEUTRAL[3],
})

export const GotoContent = ({ flowName, readonly, onFlowOpen, onClose }: GotoContentProp) => {
  const [isCloseIconHover, setCloseIconHover] = useState(false)
  const { isPlayer } = useFlowChartState()

  const handleCloseClick = () => {
    setCloseIconHover(false)
    onClose()
  }

  return (
    <>
      <richtext style={FlowCaption} text={flowName} />
      {!readonly && (
        <sprite
          image={isCloseIconHover ? RedIconString : GrayIconString}
          style={CloseIcon}
          onClick={handleCloseClick}
          onMouseOver={() => setCloseIconHover(true)}
          onMouseOut={() => setCloseIconHover(false)}
          cursor={'pointer'}
          name={NODE_CLEAR_BUTTON_ID}
        />
      )}
      {!isPlayer && <OpenFlowButton onClick={onFlowOpen} />}
    </>
  )
}
